import React from 'react';
import styles from './index.module.scss';

var ChoiceImage = function ChoiceImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt;
  return /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    className: styles.image
  });
};

export default ChoiceImage;